import {AdminAuthAccount} from '@/services/admin/AdminTypings';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: AdminAuthAccount } | undefined) {
  const { currentUser } = initialState ?? {};
  const {
    permissions,
    roles,
    authority,
    legalPerson,
    managerPerson,
    tenant,
    merchant,
    depType,
    orgChildId,
    departmentId,
    orgId,
    pimaryPost,
  } = currentUser ?? {};

  let accessMap = {
    authority: authority,
    legalPerson: legalPerson,
    managerPerson: managerPerson,
    tenant: tenant,
    merchant: merchant,
    depType,
    orgChildId,
    departmentId,
    orgId,
    pimaryPost: pimaryPost,
    roles: roles || [],
  };
  if (authority) {
    accessMap[`AUTHORITY::${authority}`] = true;
  }
  if ((permissions || []).length > 0) {
    (permissions || []).forEach((permission) => {
      accessMap[permission] = true;
    });
  }
  if ((roles || []).length > 0) {
    (roles || []).forEach((role) => {
      accessMap[role] = true;
    });
  }

  return accessMap;
}
